/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApexOptions } from 'apexcharts';

import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import Card, { CardProps } from '@mui/material/Card';
import { styled, useTheme } from '@mui/material/styles';
import Chart, { useChart } from 'src/components/chart';
import InfoIcon from '@mui/icons-material/Info';
import { useMediaQuery } from '@mui/material';

// ----------------------------------------------------------------------
const CHART_HEIGHT = 275;

const LEGEND_HEIGHT = 25;

const StyledChart = styled(Chart)(({ theme }) => ({
  height: CHART_HEIGHT,
  '& .apexcharts-canvas, .apexcharts-inner, svg, foreignObject': {
    height: `100% !important`,
  },
  '& .apexcharts-legend': {
    display: 'none !important',
    height: 0,
    right: '-6px !important',
    borderTop: `dashed 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
    justifyContent: 'center !important',
  },
}));
interface Props extends CardProps {
  title?: string;
  subheader?: string;
  chart: {
    labels: string[];
    colors?: string[];
    series: {
      name: string;
      type: string;
      fill?: string;
      data: number[];
    }[];
    options?: ApexOptions;
  };
}

export default function AnalysisWebsiteVisits({ title, subheader, chart, ...other }: Props) {
  const theme = useTheme();
  const matchesCustomBreakpoint = useMediaQuery(theme.breakpoints.down(1366));
  const matchesAnotherCustomBreakpoint = useMediaQuery(theme.breakpoints.down(1197.5));
  const { labels, colors, series, options } = chart;
  const chartOptions = useChart({
    colors,
    plotOptions: {
      bar: {
        columnWidth: '16%',
      },
    },
    fill: {
      type: series.map((i) => i.fill) as string[],
    },
    labels,
    yaxis: {
      labels: {
        formatter: (value: string | number) => {
          // Ensure we are dealing with a number before we format it
          if (typeof value === 'number') {
            const val = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
            }).format(value);
            return ` ${val}`;
          }
          return value;
        },
      },
    },
    xaxis: {
      type: 'category',
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter :(value: string | number) => {
          console.log('notenteres', value);
          // Ensure we are dealing with a number before we format it
          if (typeof value === 'number') {
            console.log('data', value);
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
            }).format(value);
          }
          return value;
        },
      },
    },
    ...options,
  });
  const responsiveChartHeight = matchesCustomBreakpoint ? 250 : CHART_HEIGHT; // Adjust chart height for small screens
  const responsiveChartOptions = {
    ...chartOptions,
    chart: {
      ...chartOptions.chart,
      height: responsiveChartHeight,
    },
    // Any other responsive option adjustments can go here
  };

  return (
    <Card {...other}>
      <CardHeader
        title={title}
        subheader={subheader}
        // action={<InfoIcon color="action" style={{ paddingLeft: '5px', color: '#4040ab' }} />}
      />
      <Box sx={{ mt: 3, mx: 3 }}>
        <Chart
          dir="ltr"
          type="line"
          series={series}
          options={responsiveChartOptions}
          width="100%"
          height={responsiveChartHeight}
        />
      </Box>
    </Card>
  );
}
